export const flags = {
  FE_DECK_THUMBNAIL: true,
  FE_PLEASE_WAIT_SCREEN_STUCK: true,
  FE_635_CAPTCHA: true,
  FE_V3_TEMPLATE_ENABLED: true,
  FE_DECKTOGPT_ONBOARDING_TOUR_MOBILE: '',
  FE_DECKTOGPT_ONBOARDING_TOUR_WEB: '',
}
